import { Injectable, TemplateRef } from '@angular/core';
import { ToastMessage, ToastOptions } from './toast.types';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts$: BehaviorSubject<ToastOptions[]> = new BehaviorSubject<ToastOptions[]>([]);

  public get toasts$(): Observable<ToastOptions[]> {
    return this._toasts$.asObservable();
  }

  public success(textOrTpl: ToastMessage, options: ToastOptions = {}): void {
    this.show(textOrTpl, {
      ...options,
      classname: 'bg-success text-light',
    });
  }

  public info(textOrTpl: ToastMessage, options: ToastOptions = {}): void {
    this.show(textOrTpl, {
      ...options,
      classname: 'bg-dark text-light',
    });
  }

  public error(textOrTpl: ToastMessage, options: ToastOptions = {}): void {
    this.show(textOrTpl, {
      ...options,
      classname: 'bg-danger text-light',
    });
  }

  public show(textOrTpl: ToastMessage, options: ToastOptions = {}) {
    const patch = textOrTpl instanceof TemplateRef
      ? { template: textOrTpl }
      : { text: textOrTpl };

    this._toasts$.next([
      ...this._toasts$.value,
      {
        ...options,
        ...patch,
      }
    ]);
  }

  public remove(toast: ToastOptions) {
    this._toasts$.next(
      this._toasts$.value.filter(t => t !== toast),
    );
  }
}
